import { render, staticRenderFns } from "./interviewQuestion.vue?vue&type=template&id=295a5d00&scoped=true&"
import script from "./interviewQuestion.vue?vue&type=script&lang=js&"
export * from "./interviewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./interviewQuestion.vue?vue&type=style&index=0&id=295a5d00&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295a5d00",
  null
  
)

export default component.exports